import { InlineError, Input } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'
import Datepicker from 'components/commons/datepicker'
import Timepicker from 'components/commons/timepicker'
import moment from 'moment'

export const GeneralData = ({ sectionRef, flashSaleDetail, onChangeForm, errorForm, date, time, onChangeDateTime }) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'General Data'}
                content={
                    <div className={'grid grid-cols-2 gap-x-16 gap-y-5'}>
                        <div className={'flex flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Nama Flash Sale</div>
                                <Input
                                    className={'flex-1'}
                                    name={'name'}
                                    placeholder={'Masukkan nama flash sale'}
                                    value={flashSaleDetail?.name}
                                    onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.name} />
                            </div>
                            <div
                                className={`flex flex-col ${(flashSaleDetail?.image_url?.base64 || flashSaleDetail?.image_url) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90 required'}>
                                    Icon Flash Sale (109.77px x 50.51px)
                                </div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                    id={'icon-flash-sale'}
                                    value={flashSaleDetail?.image_url?.base64 || flashSaleDetail?.image_url}
                                    onChange={(value) =>
                                        onChangeForm({
                                            image_url: value ? { ...value, key: 'image_url' } : value,
                                        })
                                    }
                                />
                                <InlineError className='mt-2' message={errorForm?.image_url} />
                            </div>
                        </div>
                        <div className={'flex-1 space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Description</div>
                            <Input
                                type={'text-area'}
                                className={'flex-1'}
                                name={'description'}
                                placeholder={'Masukkan deskripsi'}
                                value={flashSaleDetail?.description}
                                row={5}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.description} />
                        </div>
                        <div className={'flex flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Start Date & Time</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'date-start'}
                                        className={'flex-1'}
                                        value={date?.start}
                                        maxDate={date?.end}
                                        minDate={moment()}
                                        onChange={(value) => onChangeDateTime({ name: 'start_date', value })}
                                        format={'YYYY-MM-DD'}
                                    />
                                    <Timepicker
                                        className={'flex-1'}
                                        name={'start_time'}
                                        placeholder='Pilih Waktu'
                                        value={time?.start}
                                        disabled={!date?.start}
                                        onChange={(value) => onChangeDateTime(value)}
                                    />
                                </div>
                                <InlineError className='mt-2' message={errorForm?.date_start} />
                            </div>
                            <div
                                className={`flex flex-col ${(flashSaleDetail?.desktop_image_url?.base64 || flashSaleDetail?.desktop_image_url) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90 required'}>
                                    Background Flash Sale Desktop (1366px x 631px)
                                </div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                    id={'background-flash-sale-desktop'}
                                    value={
                                        flashSaleDetail?.desktop_image_url?.base64 || flashSaleDetail?.desktop_image_url
                                    }
                                    onChange={(value) =>
                                        onChangeForm({
                                            desktop_image_url: value ? { ...value, key: 'desktop_image_url' } : value,
                                        })
                                    }
                                />
                                <InlineError className='mt-2' message={errorForm?.desktop_image_url} />
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>End Date & Time</div>
                                <div className={'flex space-x-2'}>
                                    <Datepicker
                                        name={'date-end'}
                                        className={'flex-1'}
                                        value={date?.end}
                                        minDate={date?.start || moment()}
                                        onChange={(value) => onChangeDateTime({ name: 'end_date', value })}
                                        format={'YYYY-MM-DD'}
                                    />
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <Timepicker
                                            name={'end_time'}
                                            placeholder='Pilih Waktu'
                                            value={time?.end}
                                            disabled={!date?.end}
                                            onChange={(value) => onChangeDateTime(value)}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.time_expired} />
                                    </div>
                                </div>
                                <InlineError className={'mt-2'} message={errorForm?.date_expired} />
                            </div>
                            <div
                                className={`flex flex-col ${(flashSaleDetail?.mobile_image_url?.base64 || flashSaleDetail?.mobile_image_url) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90 required'}>
                                    Background Flash Sale Mobile (393px x 613.41px)
                                </div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                    id={'background-flash-sale-mobile'}
                                    value={
                                        flashSaleDetail?.mobile_image_url?.base64 || flashSaleDetail?.mobile_image_url
                                    }
                                    onChange={(value) =>
                                        onChangeForm({
                                            mobile_image_url: value ? { ...value, key: 'mobile_image_url' } : value,
                                        })
                                    }
                                />
                                <InlineError className='mt-2' message={errorForm?.mobile_image_url} />
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    )
}
